const technologyTypes = {
  CERTIFICABLE: 'CERTIFICABLE',
  NOT_CERTIFICABLE: 'NOT_CERTIFICABLE',
};

export { technologyTypes };
